import css from './SeasonList.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Breakpoints } from 'meta/layout/breakpoints'
import { CollectionFromIframe } from 'meta/pages/collection'

import { Grid, GridColumn } from 'components/Layout/Grid'
import { MockCollectionAnchorable } from 'components/Pages/Collection/mock'

import SeasonListItemContainer from './SeasonListItem/SeasonListItemContainer'

interface Props {
  collectionId: string
  typeticketCollectionIds: number[]
  isPerformer?: boolean
}

const SeasonList: React.FC<Props & MockCollectionAnchorable & CollectionFromIframe> = (props) => {
  const { collectionId, typeticketCollectionIds, anchorId, fromIframe, toggleContent, isPerformer } = props

  const { t } = useTranslation()

  if (typeticketCollectionIds.length === 0) {
    return null
  }

  return (
    <Grid>
      <GridColumn gridColumnStart={1} gridColumnEnd={{ [Breakpoints.tablet]: 17, [Breakpoints.mobile]: 17 }}>
        <div className={classNames(css.seasonListContainer, { [css.fromIframe]: fromIframe })}>
          <h2 className={css.title} id={anchorId}>
            {t('collection:season_tickets_title')}
          </h2>

          {typeticketCollectionIds.map((id, key) => {
            return (
              <SeasonListItemContainer
                collectionId={collectionId}
                isPerformer={isPerformer}
                typeticketCollectionId={id}
                key={key}
                fromIframe={fromIframe}
                toggleContent={toggleContent}
              />
            )
          })}
        </div>
      </GridColumn>
    </Grid>
  )
}

export default SeasonList
